import type { AssetTagBatchResponse } from '@fleet-bffs/api-contract';

/**
 * batch-assign returns 200 even when every asset rejected the tag — without
 * cleanup, a phantom tag lingers in the suggestions dropdown. This helper
 * picks out the tags we inserted this call that failed on every asset so the
 * caller can strip them from the suggestions cache. Pre-existing suggestions
 * are left alone; they may still belong to other assets in the fleet.
 */
export const collectFullyFailedInsertedTags = (
  response: AssetTagBatchResponse | undefined,
  insertedSuggestions: Set<string>,
  totalAssetCount: number
): Set<string> => {
  if (insertedSuggestions.size === 0 || totalAssetCount === 0) {
    return new Set();
  }

  const failedCounts = new Map<string, number>();
  response?.results?.forEach((result) => {
    result.failedTags.forEach(({ tag }) => {
      failedCounts.set(tag, (failedCounts.get(tag) ?? 0) + 1);
    });
  });

  return new Set(
    [...failedCounts]
      .filter(([tag, count]) => count === totalAssetCount && insertedSuggestions.has(tag))
      .map(([tag]) => tag)
  );
};
